export interface CountryCodeOption {
  value: string
  nameCn: string
  nameEn: string
}

export const countryCodeOptions: CountryCodeOption[] = [
  // 亚洲
  { nameCn: '中国', nameEn: 'China', value: '+86' },
  { nameCn: '香港', nameEn: 'Hong Kong', value: '+852' },
  { nameCn: '澳门', nameEn: 'Macao', value: '+853' },
  { nameCn: '台湾', nameEn: 'Taiwan', value: '+886' },
  { nameCn: '日本', nameEn: 'Japan', value: '+81' },
  { nameCn: '韩国', nameEn: 'South Korea', value: '+82' },
  { nameCn: '新加坡', nameEn: 'Singapore', value: '+65' },
  { nameCn: '马来西亚', nameEn: 'Malaysia', value: '+60' },
  { nameCn: '印度尼西亚', nameEn: 'Indonesia', value: '+62' },
  { nameCn: '泰国', nameEn: 'Thailand', value: '+66' },
  { nameCn: '越南', nameEn: 'Vietnam', value: '+84' },
  { nameCn: '菲律宾', nameEn: 'Philippines', value: '+63' },
  { nameCn: '缅甸', nameEn: 'Myanmar', value: '+95' },
  { nameCn: '柬埔寨', nameEn: 'Cambodia', value: '+855' },
  { nameCn: '老挝', nameEn: 'Laos', value: '+856' },
  { nameCn: '文莱', nameEn: 'Brunei', value: '+673' },
  { nameCn: '印度', nameEn: 'India', value: '+91' },
  { nameCn: '巴基斯坦', nameEn: 'Pakistan', value: '+92' },
  { nameCn: '孟加拉国', nameEn: 'Bangladesh', value: '+880' },
  { nameCn: '斯里兰卡', nameEn: 'Sri Lanka', value: '+94' },
  { nameCn: '尼泊尔', nameEn: 'Nepal', value: '+977' },
  { nameCn: '不丹', nameEn: 'Bhutan', value: '+975' },
  { nameCn: '马尔代夫', nameEn: 'Maldives', value: '+960' },
  { nameCn: '阿富汗', nameEn: 'Afghanistan', value: '+93' },
  { nameCn: '伊朗', nameEn: 'Iran', value: '+98' },
  { nameCn: '伊拉克', nameEn: 'Iraq', value: '+964' },
  { nameCn: '黎巴嫩', nameEn: 'Lebanon', value: '+961' },
  { nameCn: '叙利亚', nameEn: 'Syria', value: '+963' },
  { nameCn: '约旦', nameEn: 'Jordan', value: '+962' },
  { nameCn: '以色列', nameEn: 'Israel', value: '+972' },
  { nameCn: '巴勒斯坦', nameEn: 'Palestine', value: '+970' },
  { nameCn: '卡塔尔', nameEn: 'Qatar', value: '+974' },
  { nameCn: '巴林', nameEn: 'Bahrain', value: '+973' },
  { nameCn: '科威特', nameEn: 'Kuwait', value: '+965' },
  { nameCn: '阿曼', nameEn: 'Oman', value: '+968' },
  { nameCn: '阿联酋', nameEn: 'United Arab Emirates', value: '+971' },
  { nameCn: '沙特阿拉伯', nameEn: 'Saudi Arabia', value: '+966' },
  { nameCn: '也门', nameEn: 'Yemen', value: '+967' },
  { nameCn: '土耳其', nameEn: 'Turkey', value: '+90' },
  { nameCn: '阿塞拜疆', nameEn: 'Azerbaijan', value: '+994' },
  { nameCn: '亚美尼亚', nameEn: 'Armenia', value: '+374' },
  { nameCn: '格鲁吉亚', nameEn: 'Georgia', value: '+995' },
  { nameCn: '俄罗斯', nameEn: 'Russia', value: '+7' },
  { nameCn: '哈萨克斯坦', nameEn: 'Kazakhstan', value: '+7' },
  { nameCn: '塔吉克斯坦', nameEn: 'Tajikistan', value: '+992' },
  { nameCn: '土库曼斯坦', nameEn: 'Turkmenistan', value: '+993' },
  { nameCn: '吉尔吉斯斯坦', nameEn: 'Kyrgyzstan', value: '+996' },
  { nameCn: '乌兹别克斯坦', nameEn: 'Uzbekistan', value: '+998' },
  { nameCn: '蒙古', nameEn: 'Mongolia', value: '+976' },
  { nameCn: '朝鲜', nameEn: 'North Korea', value: '+850' },
  { nameCn: '东帝汶', nameEn: 'East Timor', value: '+670' },

  // 欧洲
  { nameCn: '英国', nameEn: 'United Kingdom', value: '+44' },
  { nameCn: '法国', nameEn: 'France', value: '+33' },
  { nameCn: '德国', nameEn: 'Germany', value: '+49' },
  { nameCn: '意大利', nameEn: 'Italy', value: '+39' },
  { nameCn: '西班牙', nameEn: 'Spain', value: '+34' },
  { nameCn: '荷兰', nameEn: 'Netherlands', value: '+31' },
  { nameCn: '比利时', nameEn: 'Belgium', value: '+32' },
  { nameCn: '瑞士', nameEn: 'Switzerland', value: '+41' },
  { nameCn: '奥地利', nameEn: 'Austria', value: '+43' },
  { nameCn: '瑞典', nameEn: 'Sweden', value: '+46' },
  { nameCn: '挪威', nameEn: 'Norway', value: '+47' },
  { nameCn: '丹麦', nameEn: 'Denmark', value: '+45' },
  { nameCn: '芬兰', nameEn: 'Finland', value: '+358' },
  { nameCn: '葡萄牙', nameEn: 'Portugal', value: '+351' },
  { nameCn: '希腊', nameEn: 'Greece', value: '+30' },
  { nameCn: '波兰', nameEn: 'Poland', value: '+48' },
  { nameCn: '捷克', nameEn: 'Czech Republic', value: '+420' },
  { nameCn: '斯洛伐克', nameEn: 'Slovakia', value: '+421' },
  { nameCn: '匈牙利', nameEn: 'Hungary', value: '+36' },
  { nameCn: '罗马尼亚', nameEn: 'Romania', value: '+40' },
  { nameCn: '保加利亚', nameEn: 'Bulgaria', value: '+359' },
  { nameCn: '爱尔兰', nameEn: 'Ireland', value: '+353' },
  { nameCn: '冰岛', nameEn: 'Iceland', value: '+354' },
  { nameCn: '马耳他', nameEn: 'Malta', value: '+356' },
  { nameCn: '塞浦路斯', nameEn: 'Cyprus', value: '+357' },
  { nameCn: '克罗地亚', nameEn: 'Croatia', value: '+385' },
  { nameCn: '斯洛文尼亚', nameEn: 'Slovenia', value: '+386' },
  { nameCn: '波黑', nameEn: 'Bosnia and Herzegovina', value: '+387' },
  { nameCn: '北马其顿', nameEn: 'North Macedonia', value: '+389' },
  { nameCn: '塞尔维亚', nameEn: 'Serbia', value: '+381' },
  { nameCn: '黑山', nameEn: 'Montenegro', value: '+382' },
  { nameCn: '科索沃', nameEn: 'Kosovo', value: '+383' },
  { nameCn: '阿尔巴尼亚', nameEn: 'Albania', value: '+355' },
  { nameCn: '乌克兰', nameEn: 'Ukraine', value: '+380' },
  { nameCn: '白俄罗斯', nameEn: 'Belarus', value: '+375' },
  { nameCn: '立陶宛', nameEn: 'Lithuania', value: '+370' },
  { nameCn: '拉脱维亚', nameEn: 'Latvia', value: '+371' },
  { nameCn: '爱沙尼亚', nameEn: 'Estonia', value: '+372' },
  { nameCn: '摩尔多瓦', nameEn: 'Moldova', value: '+373' },
  { nameCn: '卢森堡', nameEn: 'Luxembourg', value: '+352' },
  { nameCn: '列支敦士登', nameEn: 'Liechtenstein', value: '+423' },
  { nameCn: '安道尔', nameEn: 'Andorra', value: '+376' },
  { nameCn: '摩纳哥', nameEn: 'Monaco', value: '+377' },
  { nameCn: '圣马力诺', nameEn: 'San Marino', value: '+378' },
  { nameCn: '梵蒂冈', nameEn: 'Vatican City', value: '+379' },

  // 北美洲
  { nameCn: '美国', nameEn: 'United States', value: '+1' },
  { nameCn: '加拿大', nameEn: 'Canada', value: '+1' },
  { nameCn: '墨西哥', nameEn: 'Mexico', value: '+52' },
  { nameCn: '牙买加', nameEn: 'Jamaica', value: '+1' },
  { nameCn: '巴哈马', nameEn: 'Bahamas', value: '+1' },
  { nameCn: '巴巴多斯', nameEn: 'Barbados', value: '+1' },
  { nameCn: '特立尼达和多巴哥', nameEn: 'Trinidad and Tobago', value: '+1' },
  { nameCn: '伯利兹', nameEn: 'Belize', value: '+501' },
  { nameCn: '危地马拉', nameEn: 'Guatemala', value: '+502' },
  { nameCn: '萨尔瓦多', nameEn: 'El Salvador', value: '+503' },
  { nameCn: '洪都拉斯', nameEn: 'Honduras', value: '+504' },
  { nameCn: '尼加拉瓜', nameEn: 'Nicaragua', value: '+505' },
  { nameCn: '哥斯达黎加', nameEn: 'Costa Rica', value: '+506' },
  { nameCn: '巴拿马', nameEn: 'Panama', value: '+507' },
  { nameCn: '海地', nameEn: 'Haiti', value: '+509' },
  { nameCn: '圣皮埃尔和密克隆', nameEn: 'Saint Pierre and Miquelon', value: '+508' },
  { nameCn: '瓜德罗普', nameEn: 'Guadeloupe', value: '+590' },
  { nameCn: '马提尼克', nameEn: 'Martinique', value: '+596' },
  { nameCn: '福克兰群岛', nameEn: 'Falkland Islands', value: '+500' },

  // 南美洲
  { nameCn: '巴西', nameEn: 'Brazil', value: '+55' },
  { nameCn: '阿根廷', nameEn: 'Argentina', value: '+54' },
  { nameCn: '哥伦比亚', nameEn: 'Colombia', value: '+57' },
  { nameCn: '秘鲁', nameEn: 'Peru', value: '+51' },
  { nameCn: '委内瑞拉', nameEn: 'Venezuela', value: '+58' },
  { nameCn: '智利', nameEn: 'Chile', value: '+56' },
  { nameCn: '厄瓜多尔', nameEn: 'Ecuador', value: '+593' },
  { nameCn: '玻利维亚', nameEn: 'Bolivia', value: '+591' },
  { nameCn: '巴拉圭', nameEn: 'Paraguay', value: '+595' },
  { nameCn: '乌拉圭', nameEn: 'Uruguay', value: '+598' },
  { nameCn: '苏里南', nameEn: 'Suriname', value: '+597' },
  { nameCn: '圭亚那', nameEn: 'Guyana', value: '+592' },
  { nameCn: '法属圭亚那', nameEn: 'French Guiana', value: '+594' },
  { nameCn: '荷属安的列斯', nameEn: 'Netherlands Antilles', value: '+599' },

  // 大洋洲
  { nameCn: '澳大利亚', nameEn: 'Australia', value: '+61' },
  { nameCn: '新西兰', nameEn: 'New Zealand', value: '+64' },
  { nameCn: '斐济', nameEn: 'Fiji', value: '+679' },
  { nameCn: '汤加', nameEn: 'Tonga', value: '+676' },
  { nameCn: '萨摩亚', nameEn: 'Samoa', value: '+685' },
  { nameCn: '新喀里多尼亚', nameEn: 'New Caledonia', value: '+687' },
  { nameCn: '法属波利尼西亚', nameEn: 'French Polynesia', value: '+689' },
  { nameCn: '瓦努阿图', nameEn: 'Vanuatu', value: '+678' },
  { nameCn: '所罗门群岛', nameEn: 'Solomon Islands', value: '+677' },
  { nameCn: '巴布亚新几内亚', nameEn: 'Papua New Guinea', value: '+675' },
  { nameCn: '帕劳', nameEn: 'Palau', value: '+680' },
  { nameCn: '瓦利斯和富图纳', nameEn: 'Wallis and Futuna', value: '+681' },
  { nameCn: '库克群岛', nameEn: 'Cook Islands', value: '+682' },
  { nameCn: '纽埃', nameEn: 'Niue', value: '+683' },
  { nameCn: '基里巴斯', nameEn: 'Kiribati', value: '+686' },
  { nameCn: '图瓦卢', nameEn: 'Tuvalu', value: '+688' },
  { nameCn: '托克劳', nameEn: 'Tokelau', value: '+690' },
  { nameCn: '密克罗尼西亚', nameEn: 'Micronesia', value: '+691' },
  { nameCn: '马绍尔群岛', nameEn: 'Marshall Islands', value: '+692' },
  { nameCn: '诺福克岛', nameEn: 'Norfolk Island', value: '+672' },
  { nameCn: '瑙鲁', nameEn: 'Nauru', value: '+674' },

  // 非洲
  { nameCn: '埃及', nameEn: 'Egypt', value: '+20' },
  { nameCn: '南非', nameEn: 'South Africa', value: '+27' },
  { nameCn: '摩洛哥', nameEn: 'Morocco', value: '+212' },
  { nameCn: '阿尔及利亚', nameEn: 'Algeria', value: '+213' },
  { nameCn: '突尼斯', nameEn: 'Tunisia', value: '+216' },
  { nameCn: '利比亚', nameEn: 'Libya', value: '+218' },
  { nameCn: '苏丹', nameEn: 'Sudan', value: '+249' },
  { nameCn: '埃塞俄比亚', nameEn: 'Ethiopia', value: '+251' },
  { nameCn: '肯尼亚', nameEn: 'Kenya', value: '+254' },
  { nameCn: '坦桑尼亚', nameEn: 'Tanzania', value: '+255' },
  { nameCn: '乌干达', nameEn: 'Uganda', value: '+256' },
  { nameCn: '布隆迪', nameEn: 'Burundi', value: '+257' },
  { nameCn: '卢旺达', nameEn: 'Rwanda', value: '+250' },
  { nameCn: '吉布提', nameEn: 'Djibouti', value: '+253' },
  { nameCn: '索马里', nameEn: 'Somalia', value: '+252' },
  { nameCn: '赞比亚', nameEn: 'Zambia', value: '+260' },
  { nameCn: '津巴布韦', nameEn: 'Zimbabwe', value: '+263' },
  { nameCn: '纳米比亚', nameEn: 'Namibia', value: '+264' },
  { nameCn: '马拉维', nameEn: 'Malawi', value: '+265' },
  { nameCn: '莱索托', nameEn: 'Lesotho', value: '+266' },
  { nameCn: '博茨瓦纳', nameEn: 'Botswana', value: '+267' },
  { nameCn: '斯威士兰', nameEn: 'Eswatini', value: '+268' },
  { nameCn: '科摩罗', nameEn: 'Comoros', value: '+269' },
  { nameCn: '冈比亚', nameEn: 'Gambia', value: '+220' },
  { nameCn: '塞内加尔', nameEn: 'Senegal', value: '+221' },
  { nameCn: '毛里塔尼亚', nameEn: 'Mauritania', value: '+222' },
  { nameCn: '马里', nameEn: 'Mali', value: '+223' },
  { nameCn: '几内亚', nameEn: 'Guinea', value: '+224' },
  { nameCn: '科特迪瓦', nameEn: 'Ivory Coast', value: '+225' },
  { nameCn: '布基纳法索', nameEn: 'Burkina Faso', value: '+226' },
  { nameCn: '尼日尔', nameEn: 'Niger', value: '+227' },
  { nameCn: '多哥', nameEn: 'Togo', value: '+228' },
  { nameCn: '贝宁', nameEn: 'Benin', value: '+229' },
  { nameCn: '毛里求斯', nameEn: 'Mauritius', value: '+230' },
  { nameCn: '利比里亚', nameEn: 'Liberia', value: '+231' },
  { nameCn: '塞拉利昂', nameEn: 'Sierra Leone', value: '+232' },
  { nameCn: '加纳', nameEn: 'Ghana', value: '+233' },
  { nameCn: '尼日利亚', nameEn: 'Nigeria', value: '+234' },
  { nameCn: '乍得', nameEn: 'Chad', value: '+235' },
  { nameCn: '中非', nameEn: 'Central African Republic', value: '+236' },
  { nameCn: '喀麦隆', nameEn: 'Cameroon', value: '+237' },
  { nameCn: '佛得角', nameEn: 'Cape Verde', value: '+238' },
  { nameCn: '圣多美和普林西比', nameEn: 'Sao Tome and Principe', value: '+239' },
  { nameCn: '赤道几内亚', nameEn: 'Equatorial Guinea', value: '+240' },
  { nameCn: '加蓬', nameEn: 'Gabon', value: '+241' },
  { nameCn: '刚果(布)', nameEn: 'Republic of the Congo', value: '+242' },
  { nameCn: '刚果(金)', nameEn: 'Democratic Republic of the Congo', value: '+243' },
  { nameCn: '安哥拉', nameEn: 'Angola', value: '+244' },
  { nameCn: '几内亚比绍', nameEn: 'Guinea-Bissau', value: '+245' },
  { nameCn: '英属印度洋领地', nameEn: 'British Indian Ocean Territory', value: '+246' },
  { nameCn: '塞舌尔', nameEn: 'Seychelles', value: '+248' },
  { nameCn: '圣赫勒拿', nameEn: 'Saint Helena', value: '+290' },
  { nameCn: '厄立特里亚', nameEn: 'Eritrea', value: '+291' },
  { nameCn: '阿鲁巴', nameEn: 'Aruba', value: '+297' },
  { nameCn: '法罗群岛', nameEn: 'Faroe Islands', value: '+298' },
  { nameCn: '格陵兰', nameEn: 'Greenland', value: '+299' },
  { nameCn: '直布罗陀', nameEn: 'Gibraltar', value: '+350' }
]
